import { releasesCatalogGetters } from "./releases/getters";
import { productsCatalogGetters } from "./products/getters";
import { product_groupsCatalogGetters } from "./product_groups/getters";
import { tracksCatalogGetters } from "./tracks/getters";
import { artistsCatalogGetters } from "./artists/getters";
import { labelsCatalogGetters } from "./labels/getters";
import { CatalogModulePluginStore } from "./plugin-store";
import { projectsCatalogGetters } from "./projects/getters";
export const getters = {
  ...productsCatalogGetters,
  ...releasesCatalogGetters,
  ...product_groupsCatalogGetters,
  ...tracksCatalogGetters,
  ...artistsCatalogGetters,
  ...labelsCatalogGetters,
  ...projectsCatalogGetters,
  ...CatalogModulePluginStore.getters
};
